<!-- container principal -->
<div class="component-main-container">
  <!-- componentização do header -->
  <div class="header">
    <app-page-header parentTitle="{{ 'equipment-type.equipment-type-header' | translate }}"
      pageTitle="{{ 'equipment-type.equipment-type-label' | translate }}"></app-page-header>
  </div>
  <!-- faz a tela se comportar em linha -->
  <div class="row">
    <!-- distribui a dimensão da tela -->
    <div class="col-lg-5 col-xl-4 col-sm-12">
      <!-- div armazenadora das box de relatório -->
      <div class="component-forms-box">
        <!-- componentização da box de seleção do tipo registro -->
        <app-register-form></app-register-form>

        <!-- box de registro de equipamento -->
        <div class="form-fields-box" [ngClass]="!registerEquipmentType || editorController ? 'closed' : ''"
          [formGroup]="equipmentTypeCreateForm">
          <h2 (click)="registerEquipmentTypeOpen()">
            {{ "equipment-type.create-equipment-type-label" | translate }}
          </h2>
          <hr [ngClass]="!registerEquipmentType ? 'hr-open' : ''" />

          <!-- mat responsável por armazenar o formulario de informações, hardware e firmware e comandos -->
          <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
            <!-- formulário de informações -->
            <mat-tab label="{{ 'equipment-type.information-label' | translate }}">
              <section>
                <mat-checkbox (change)="isGateway($event.checked)">{{
                  "equipment-type.is-gateway" | translate
                  }}</mat-checkbox>
              </section>

              <div class="form-step">
                <div class="circle-number">1</div>
                <mat-form-field appearance="outline">
                  <mat-label>{{
                    "equipment-type.release-data-label" | translate
                    }}</mat-label>
                  <input matInput type="date" formControlName="releaseDate" />
                </mat-form-field>
              </div>

              <div class="form-step">
                <div class="circle-number">2</div>
                <mat-form-field appearance="outline">
                  <mat-label>{{
                    "equipment-type.reference-label" | translate
                    }}</mat-label>
                  <input matInput formControlName="reference" />
                </mat-form-field>
              </div>

              <div class="form-step version">
                <div class="circle-number">3</div>
                <mat-form-field appearance="outline" title="{{ 'equipment-type.version-major' | translate }}">
                  <mat-label>{{
                    "equipment-type.version-major" | translate
                    }}</mat-label>
                  <input matInput type="number" formControlName="major" />
                </mat-form-field>
                <mat-form-field appearance="outline" title="{{ 'equipment-type.version-minor' | translate }}">
                  <mat-label>{{
                    "equipment-type.version-minor" | translate
                    }}</mat-label>
                  <input matInput type="number" formControlName="minor" />
                </mat-form-field>
                <mat-form-field appearance="outline" title="{{ 'equipment-type.version-revision' | translate }}">
                  <mat-label>{{
                    "equipment-type.version-revision" | translate
                    }}</mat-label>
                  <input matInput type="number" formControlName="revision" />
                </mat-form-field>
              </div>

              <div class="form-step">
                <div class="circle-number">4</div>
                <mat-form-field appearance="outline">
                  <mat-label>{{
                    "equipment-type.description-label" | translate
                    }}</mat-label>
                  <textarea matInput formControlName="description"></textarea>
                </mat-form-field>
              </div>

              @if (!equipmentTypeCreateLoading) {
              <button title="{{ 'equipment-type.save-btn' | translate }}" class="btn btn-success"
                (click)="createEquipmentType()" style="width: 100%">
                {{ "equipment-type.save-btn" | translate }}
              </button>
              }
              @if (equipmentTypeCreateLoading) {
              <mat-spinner [diameter]="30"></mat-spinner>
              }
            </mat-tab>

            <!-- formulário de hardware e firmware -->
            <mat-tab label="{{
                'equipment-type.hardware-and-firmware-label' | translate
              }}">
              <div class="form-step">
                <div class="circle-number">1</div>
                <mat-form-field appearance="outline">
                  <mat-label> Hardwares </mat-label>
                  <mat-select formControlName="hardware">
                    @for (hardwares of hardwaresList; track hardwares.id) {
                    <mat-option [value]="hardwares.id" (click)="filterCompatibleFirmware(hardwares.id)">
                      {{ hardwares.name }} - {{ hardwares.major }}.{{
                      hardwares.minor
                      }}.{{ hardwares.revision }}
                    </mat-option>
                    }
                    @if (hardwaresList.length === 0) {
                    <mat-option>
                      {{
                      "equipment-type.there-not-compatible-hardware"
                      | translate
                      }}
                    </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="form-step">
                <div class="circle-number">2</div>
                <mat-form-field appearance="outline" class="response-properties">
                  <mat-label>{{
                    "equipment-type.compatible-firmware" | translate
                    }}</mat-label>
                  @if (compatiblefirmwaresList.length > 0) {
                  <mat-select formControlName="compatiblefirmware" multiple>
                    @for (firmware of compatiblefirmwaresList; track firmware.id) {
                    <mat-option [value]="firmware.id">
                      {{ firmware.name }} ({{ firmware.major }}.{{
                      firmware.minor
                      }}.{{ firmware.revision }})
                    </mat-option>
                    }
                  </mat-select>
                  }
                  @if (compatiblefirmwaresList.length === 0) {
                  <mat-select>
                    <mat-option disabled>{{
                      "equipment-type.there-not-compatible-firmware"
                      | translate
                      }}
                    </mat-option>
                  </mat-select>
                  }
                </mat-form-field>
              </div>

              <!-- formulário de criação de hardware -->
              <mat-accordion [formGroup]="createHardwareAndFirmwareForm">
                <mat-expansion-panel (opened)="panelOpenHardware = true" (closed)="panelOpenHardware = false">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      {{ "equipment-type.new-hardware" | translate }}
                    </mat-panel-title>
                  </mat-expansion-panel-header>

                  <div class="form-step">
                    <div class="circle-number">1</div>
                    <mat-form-field appearance="outline">
                      <mat-label>{{
                        "equipment-type.name-label" | translate
                        }}</mat-label>
                      <input matInput formControlName="referenceHardware" />
                    </mat-form-field>
                  </div>

                  <div class="form-step">
                    <div class="circle-number">2</div>
                    <mat-form-field appearance="outline">
                      <mat-label>{{
                        "equipment-type.release-data-label" | translate
                        }}</mat-label>
                      <input matInput type="date" formControlName="releaseDateHardware" />
                    </mat-form-field>
                  </div>

                  <div class="form-step version">
                    <div class="circle-number">4</div>
                    <mat-form-field appearance="outline" title="{{ 'equipment-type.version-major' | translate }}">
                      <mat-label>{{
                        "equipment-type.version-major" | translate
                        }}</mat-label>
                      <input matInput type="number" formControlName="majorHardware" />
                    </mat-form-field>
                    <mat-form-field appearance="outline" title="{{ 'equipment-type.version-minor' | translate }}">
                      <mat-label>{{
                        "equipment-type.version-minor" | translate
                        }}</mat-label>
                      <input matInput type="number" formControlName="minorHardware" />
                    </mat-form-field>
                    <mat-form-field appearance="outline" title="{{
                        'equipment-type.version-revision' | translate
                      }}">
                      <mat-label>{{
                        "equipment-type.version-revision" | translate
                        }}</mat-label>
                      <input matInput type="number" formControlName="revisionHardware" />
                    </mat-form-field>
                  </div>

                  <div class="form-step">
                    <div class="circle-number">5</div>
                    <mat-form-field appearance="outline">
                      <mat-label>{{
                        "equipment-type.description-label" | translate
                        }}</mat-label>
                      <textarea matInput formControlName="descriptionHardware"></textarea>
                    </mat-form-field>
                  </div>

                  @if (!hardwareCreateLoading) {
                  <button title="Salvar" class="btn btn-success" (click)="createHardware()">
                    {{ "equipment-type.save-btn" | translate }}
                  </button>
                  }
                  @if (hardwareCreateLoading) {
                  <mat-spinner [diameter]="30"></mat-spinner>
                  }
                </mat-expansion-panel>

                <!-- formulário de criação de firmware -->
                <mat-expansion-panel (opened)="panelOpenFirmware = true" (closed)="panelOpenFirmware = false">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      {{ "equipment-type.new-firmware" | translate }}
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="form-step">
                    <div class="circle-number">1</div>
                    <mat-form-field appearance="outline">
                      <mat-label>{{
                        "equipment-type.name-label" | translate
                        }}</mat-label>
                      <input matInput formControlName="referenceFirmware" />
                    </mat-form-field>
                  </div>

                  <div class="form-step">
                    <div class="circle-number">2</div>
                    <mat-form-field appearance="outline">
                      <mat-label>{{
                        "equipment-type.release-data" | translate
                        }}</mat-label>
                      <input matInput type="date" formControlName="releaseDateFirmware" />
                    </mat-form-field>
                  </div>

                  <div class="form-step version">
                    <div class="circle-number">3</div>
                    <mat-form-field appearance="outline" title="{{ 'equipment-type.version-major' | translate }}">
                      <mat-label>{{
                        "equipment-type.version-major" | translate
                        }}</mat-label>
                      <input matInput type="number" formControlName="majorFirmware" />
                    </mat-form-field>
                    <mat-form-field appearance="outline" title="{{ 'equipment-type.version-minor' | translate }}">
                      <mat-label>{{
                        "equipment-type.version-minor" | translate
                        }}</mat-label>
                      <input matInput type="number" formControlName="minorFirmware" />
                    </mat-form-field>
                    <mat-form-field appearance="outline" title="{{
                        'equipment-type.version-revision' | translate
                      }}">
                      <mat-label>{{
                        "equipment-type.version-revision" | translate
                        }}</mat-label>
                      <input matInput type="number" formControlName="revisionFirmware" />
                    </mat-form-field>
                  </div>

                  <div class="form-step">
                    <div class="circle-number">4</div>
                    <mat-form-field appearance="outline">
                      <mat-label>{{
                        "equipment-type.description-label" | translate
                        }}</mat-label>
                      <textarea matInput formControlName="descriptionFirmware"></textarea>
                    </mat-form-field>
                  </div>

                  @if (!firmwareCreateLoading) {
                  <button title="Salvar" class="btn btn-success" (click)="createFirmware()">
                    {{ "equipment-type.save-btn" | translate }}
                  </button>
                  }
                  @if (firmwareCreateLoading) {
                  <mat-spinner [diameter]="30"></mat-spinner>
                  }
                </mat-expansion-panel>
              </mat-accordion>
            </mat-tab>

            <!-- formulário de comandos -->
            @if (!isGatewaySelected) {
            <mat-tab label="{{ 'equipment-type.commands-label' | translate }}">
              <div class="form-step">
                <div class="checkbox">
                  <section>
                    <mat-checkbox formControlName="hasClockSync" (change)="hasClockSyncChecked($event.checked)">
                      {{ "equipment-type.has-clock-label" | translate }}
                    </mat-checkbox>
                  </section>
                  <section>
                    <mat-checkbox formControlName="hasActuation" (change)="hasActuationChecked($event.checked)">
                      {{ "equipment-type.has-actuation-label" | translate }}
                    </mat-checkbox>
                  </section>
                </div>
                <div class="checkbox">
                  <section>
                    <mat-checkbox formControlName="hasPowerQuality" (change)="hasPowerQualityChecked($event.checked)">
                      {{
                      "equipment-type.has-power-quality-label" | translate
                      }}</mat-checkbox>
                  </section>
                  <section>
                    <mat-checkbox formControlName="oldCrc" (change)="oldCrcChecked($event.checked)">
                      {{
                      "equipment-type.has-old-crc-label" | translate
                      }}</mat-checkbox>
                  </section>
                </div>
              </div>
              <!-- Título para adição de comandos -->
              <div class="form-step">
                <div class="checkbox">
                  <span><b>{{ "equipment-type.add-commands-title" | translate }}:</b></span>
                </div>
              </div>
              <!-- Botão para adicionar comandos de consulta -->
              <div class="form-step">
                <button mat-fab extended color="primary" aria-label="Criar comando" title="{{
                    'equipment-type.create-command-label' | translate
                  }}" (click)="openModalQueryCommands()" style="margin: 5px">
                  <mat-icon>control_point</mat-icon>
                  {{ "equipment-type.query-commands" | translate }}
                </button>
                <!-- Botão para adicionar comandos de configuração -->
                <button mat-fab extended color="primary" aria-label="Criar comando" title="{{
                    'equipment-type.create-command-label' | translate
                  }}" (click)="openModalConfigCommands()">
                  <mat-icon>control_point</mat-icon>{{ "equipment-type.config-commands" | translate }}
                </button>
              </div>
              <!-- Aba de adição dos comandos de consulta -->
              @if (queryCommands.length > 0 && !editorController) {
              <div class="commands">
                <h2>{{ "equipment-type.query-commands" | translate }}</h2>
                <h4>
                  {{ "equipment-type.query-commands-sub-title" | translate }}
                </h4>
                @for (query of queryCommands; track query; let i = $index) {
                <mat-chip-set class="example-chip">
                  <mat-chip class="example-box" cdkDrag>
                    <span> {{ query?.responseProperties }} </span>
                    <span>
                      (
                      @if (query?.type === 'STATUS') {
                      <span>
                        {{ "equipment-type.queryCommands-status" | translate }}
                      </span>
                      }
                      @if (query?.type === 'PARAMETERS') {
                      <span>
                        {{
                        "equipment-type.queryCommands-parameters" | translate
                        }}
                      </span>
                      }
                      @if (query?.type === 'DIAGNOSTIC') {
                      <span>
                        {{
                        "equipment-type.queryCommands-diagnostic" | translate
                        }}
                      </span>
                      }
                      @if (query?.type === 'MEASUREMENT') {
                      <span>
                        {{
                        "equipment-type.queryCommands-measurement" | translate
                        }}
                      </span>
                      }
                      @if (query?.type === 'LATEST_MEASUREMENT') {
                      <span>
                        {{
                        "equipment-type.queryCommands-latest-measurement"
                        | translate
                        }}</span>
                      }
                      @if (query?.type === 'VERSION') {
                      <span>
                        {{ "equipment-type.queryCommands-version" | translate }}
                      </span>
                      }
                      )
                    </span>
                    <button (click)="editQueryCommands(i)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" style="cursor: pointer"
                        fill="currentColor" class="bi bi-pencil" viewBox="0 0 16 16">
                        <path
                          d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z" />
                      </svg>
                    </button>
                    <button (click)="clearQueryCommandsByIndex(i)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-trash3" viewBox="0 0 16 16" style="cursor: pointer">
                        <path
                          d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                      </svg>
                    </button>
                  </mat-chip>
                </mat-chip-set>
                }
              </div>
              }
              <!-- Aba de adição dos comandos de configuração -->
              @if (configCommands.length > 0 && !editorController) {
              <div class="commands">
                <h2>{{ "equipment-type.config-commands" | translate }}</h2>
                <h4>
                  {{ "equipment-type.config-commands-sub-title" | translate }}
                </h4>
                @for (commands of configCommands; track commands; let i = $index) {
                <mat-chip-set class="example-chip">
                  <mat-chip class="example-box">
                    <span>{{ commands?.reference }}</span>
                    <span>
                      (
                      @if (commands?.maxValue || commands?.minValue) {
                      <span>
                        {{ commands?.minValue }}, {{ commands?.maxValue }}
                      </span>
                      }
                      @if (commands?.choices) {
                      <span>
                        @for (choice of commands.choices; track choice) {
                        <span>
                          {{ choice?.description }}
                        </span>
                        }
                      </span>
                      }
                      )
                    </span>
                    <button (click)="editConfigCommands(i)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" style="cursor: pointer"
                        fill="currentColor" class="bi bi-pencil" viewBox="0 0 16 16">
                        <path
                          d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z" />
                      </svg>
                    </button>
                    <button (click)="clearConfigCommandsByIndex(i)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-trash3" viewBox="0 0 16 16" style="cursor: pointer">
                        <path
                          d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                      </svg>
                    </button>
                  </mat-chip>
                </mat-chip-set>
                }
              </div>
              }
            </mat-tab>
            }
          </mat-tab-group>
        </div>

        <!-- formulário de filtro -->
        <div class="form-fields-box" [ngClass]="!filterEquipmentType ? 'closed' : ''"
          [formGroup]="equipmentTypeFilterForm">
          <h2 (click)="filterEquipmentTypeOpen()">
            {{ "equipment-type.filter-equipment-type" | translate }}
          </h2>
          <hr [ngClass]="!filterEquipmentType ? 'hr-open' : ''" />

          <div class="form-step">
            <div class="circle-number">1</div>
            <mat-form-field appearance="outline">
              <mat-label>{{
                "equipment-type.name-label" | translate
                }}</mat-label>
              <input matInput formControlName="reference" />
            </mat-form-field>
          </div>

          <div class="form-step version">
            <div class="circle-number">2</div>
            <mat-form-field appearance="outline" title="{{ 'equipment-type.version-major' | translate }}">
              <mat-label>{{
                "equipment-type.version-major" | translate
                }}</mat-label>
              <input matInput type="number" formControlName="major" />
            </mat-form-field>
            <mat-form-field appearance="outline" title="{{ 'equipment-type.version-minor' | translate }}">
              <mat-label>{{
                "equipment-type.version-minor" | translate
                }}</mat-label>
              <input matInput type="number" formControlName="minor" />
            </mat-form-field>
            <mat-form-field appearance="outline" title="{{ 'equipment-type.version-revision' | translate }}">
              <mat-label>{{
                "equipment-type.version-revision" | translate
                }}</mat-label>
              <input matInput type="number" formControlName="revision" />
            </mat-form-field>
          </div>

          @if (!equipmentTypeLoading) {
          <button title="Filtrar" class="btn btn-success" (click)="equipmentTypeFilter(null)">
            {{ "equipment-type.filter-btn" | translate }}
          </button>
          }
          @if (equipmentTypeLoading) {
          <mat-spinner [diameter]="30"></mat-spinner>
          }
        </div>
      </div>
    </div>

    @if (paginationProperties.total) {
    <div class="col-lg-7 col-xl-8 col-sm-12">
      @if (length > 0) {
      <app-table-header [itensNumber]="paginationProperties.count" [totalNumber]="paginationProperties.total"
        [hasCSV]="true" [hasPDF]="true" [loadingData$]="fileLoading" (downloadCSV)="generateFileData(null, 'CSV')"
        (downloadPDF)="generateFileData(null, 'PDF')">
      </app-table-header>
      }
      <!-- Sessão tabela -->
      @if (ELEMENT_DATA.length) {
      <div class="table-container mt-2 mt-lg-3 mt-xl-3">
        <p-table [value]="ELEMENT_DATA" [paginator]="true" dataKey="id" [rows]="pageSize" [totalRecords]="length"
          [showPageLinks]="false" [showFirstLastIcon]="false" [lazy]="true" (onPage)="pageChanged($event)">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="reference"> {{ "equipment-type.reference-label" | translate }}
              </th>
              <th pSortableColumn="version"> {{ "equipment-type.version-label" | translate }}</th>
              <th pSortableColumn="release-data"> {{ "equipment-type.release-data-label" | translate }}</th>
              <th pSortableColumn="actions"> {{ "equipment-type.actions" | translate }}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-columns="columns" let-ri="rowIndex">
            <tr>
              <td>
                {{row.reference}}
              </td>
              <td>
                {{ row.major }}.{{ row.minor }}.{{ row.revision }}
              </td>
              <td>
                {{ row.releaseDate }}
              </td>
              <td>
                <p-button (click)="openSidebarUpdate(false, row)" styleClass="btn-actions" [rounded]="true"
                  icon="pi pi-pen-to-square" />

                <p-button (click)="openSidebarUpdate(true, row)" styleClass="btn-view" [rounded]="true"
                  icon="pi pi-eye" />

              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      }
    </div>
    }

    <!-- Modal de edição de tipos de equipamentos -->
    @if (editorController) {
    <div class="sidebar-edit" [formGroup]="updateEquipmentTypeForm">
      <mat-icon (click)="closeSidebarUpdate()"> clear </mat-icon>
      <h2 class="title-edit">
        {{ "equipment-type.edit-equipment-type-title" | translate }}
      </h2>
      <hr />
      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="center">
        <mat-tab label="Informações">
          <br />
          <section class="checkbox-gateway">
            <mat-checkbox (change)="isGatewayCkeckedUpdate($event.checked)" formControlName="isGateway">
              {{ "equipment-type.is-gateway" | translate }}
            </mat-checkbox>
          </section>
          <div>
            <mat-form-field appearance="outline">
              <mat-label>
                {{ "equipment-type.release-data-label" | translate }}
              </mat-label>
              <input matInput type="date" formControlName="releaseDate" />
            </mat-form-field>
          </div>
          <div>
            @if (!isGatewaySelectedUpdate) {
            <mat-form-field appearance="outline">
              <mat-label>
                {{ "equipment-type.reference-label" | translate }}
              </mat-label>
              <input matInput formControlName="reference" [readonly]="true" />
            </mat-form-field>
            }
          </div>
          <div class="version">
            <mat-form-field appearance="outline">
              <mat-label>
                {{ "equipment-type.version-major" | translate }}
              </mat-label>
              <input matInput type="number" formControlName="major" [readonly]="true" />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>
                {{ "equipment-type.version-minor" | translate }}
              </mat-label>
              <input matInput type="number" formControlName="minor" [readonly]="true" />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>
                {{ "equipment-type.version-revision" | translate }}
              </mat-label>
              <input matInput type="number" formControlName="revision" [readonly]="true" />
            </mat-form-field>
          </div>
          <mat-form-field appearance="outline">
            <mat-label>
              {{ "equipment-type.description-label" | translate }}
            </mat-label>
            <textarea matInput formControlName="description"></textarea>
          </mat-form-field>
          @if (!equipmentTypeLoading) {
          <button title="Salvar" class="btn btn-success" [disabled]="viewController" (click)="updateEquipmentType()">
            {{ "equipment-type.save-btn" | translate }}
          </button>
          }
          @if (equipmentTypeLoading) {
          <mat-spinner [diameter]="30"></mat-spinner>
          }
        </mat-tab>
        <mat-tab label="Hadwares e Firmwares">
          <br />
          <mat-form-field appearance="outline">
            <mat-label> Hardware </mat-label>
            <mat-select #value formControlName="hardwareSelected">
              <!-- Lista todos os hardwares passa o id do hardware já cadastrado -->
              @for (hardwares of hardwaresList; track hardwares.id) {
              <mat-option [value]="hardwares.id" (click)="filterCompatibleFirmware(hardwares.id)">
                {{ hardwares.name }} - {{ hardwares.major }}.{{
                hardwares.minor
                }}.{{ hardwares.revision }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <br />
          <mat-form-field appearance="outline">
            <mat-label>
              {{ "equipment-type.compatible-firmware" | translate }}
            </mat-label>
            <mat-select multiple>
              <!-- Método será chamado quando todos os firmwares forem selecionadas -->
              <mat-option [disabled]="viewController" (click)="checkAllCompatiblesFirmwares(selectAllFirmwares)" #selectAllFirmwares>
                Todos</mat-option>
              <!-- Método é chamado sempre que houver uma alteração nos firmwares selecionados -->
              @for (firmware of compatiblefirmwaresList; track firmware) {
              <mat-checkbox color="primary" [disabled]="viewController" (change)="checkFirmwareUpdate(firmware)" [checked]="firmware.checked"
                [id]="firmware.id">
                {{ firmware.name }} ({{ firmware.major }}.{{
                firmware.minor
                }}.{{ firmware.revision }})
              </mat-checkbox>
              }
            </mat-select>
          </mat-form-field>
          <br />
          <!-- formulário de criação de hardware -->
          <mat-accordion [formGroup]="createHardwareAndFirmwareForm">
            <mat-expansion-panel (opened)="panelOpenHardware = true" (closed)="panelOpenHardware = false" [disabled]="viewController">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{ "equipment-type.new-hardware" | translate }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="container-flex">
                <div class="item">
                  <mat-form-field appearance="outline">
                    <mat-label>{{
                      "equipment-type.name-label" | translate
                      }}</mat-label>
                    <input matInput formControlName="referenceHardware" />
                  </mat-form-field>
                </div>
                <div class="item">
                  <mat-form-field appearance="outline">
                    <mat-label>{{
                      "equipment-type.release-data-label" | translate
                      }}</mat-label>
                    <input matInput type="date" formControlName="releaseDateHardware" />
                  </mat-form-field>
                </div>
              </div>
              <div class="version">
                <mat-form-field appearance="outline">
                  <mat-label>
                    {{ "equipment-type.version-major" | translate }}
                  </mat-label>
                  <input matInput type="number" formControlName="majorHardware" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>
                    {{ "equipment-type.version-minor" | translate }}
                  </mat-label>
                  <input matInput type="number" formControlName="minorHardware" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>
                    {{ "equipment-type.version-revision" | translate }}
                  </mat-label>
                  <input matInput type="number" formControlName="revisionHardware" />
                </mat-form-field>
              </div>
              <mat-form-field appearance="outline">
                <mat-label>
                  {{ "equipment-type.description-label" | translate }}
                </mat-label>
                <textarea matInput formControlName="descriptionHardware"></textarea>
              </mat-form-field>
              <br />
              @if (!hardwareCreateLoading) {
              <button [disabled]="viewController" title="Salvar" class="btn btn-success" id="button-new-hardware" (click)="createHardware()">
                {{ "equipment-type.save-btn" | translate }}
              </button>
              }
              @if (hardwareCreateLoading) {
              <mat-spinner [diameter]="30"></mat-spinner>
              }
            </mat-expansion-panel>
            <mat-expansion-panel (opened)="panelOpenFirmware = true" (closed)="panelOpenFirmware = false" [disabled]="viewController">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{ "equipment-type.new-firmware" | translate }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="container-flex">
                <div class="item">
                  <mat-form-field appearance="outline">
                    <mat-label>{{
                      "equipment-type.name-label" | translate
                      }}</mat-label>
                    <input matInput formControlName="referenceFirmware" [disabled]="viewController" />
                  </mat-form-field>
                </div>
                <div class="item">
                  <mat-form-field appearance="outline">
                    <mat-label>{{"equipment-type.release-data-label" | translate}}</mat-label>
                    <input matInput type="date" formControlName="releaseDateFirmware" [disabled]="viewController"/>
                  </mat-form-field>
                </div>
              </div>
              <div class="version">
                <mat-form-field appearance="outline" title="{{ 'equipment-type.version-major' | translate }}">
                  <mat-label>{{
                    "equipment-type.version-major" | translate
                    }}</mat-label>
                  <input matInput type="number" formControlName="majorFirmware" [disabled]="viewController" />
                </mat-form-field>
                <mat-form-field appearance="outline" title="{{ 'equipment-type.version-minor' | translate }}">
                  <mat-label>{{
                    "equipment-type.version-minor" | translate
                    }}</mat-label>
                  <input matInput type="number" formControlName="minorFirmware" [disabled]="viewController"/>
                </mat-form-field>
                <mat-form-field appearance="outline" title="{{ 'equipment-type.version-revision' | translate }}">
                  <mat-label>{{
                    "equipment-type.version-revision" | translate
                    }}</mat-label>
                  <input matInput type="number" formControlName="revisionFirmware" [disabled]="viewController" />
                </mat-form-field>
              </div>
              <mat-form-field appearance="outline">
                <mat-label>{{
                  "equipment-type.description-label" | translate
                  }}</mat-label>
                <textarea matInput formControlName="descriptionFirmware" [disabled]="viewController"></textarea>
              </mat-form-field>
              @if (!firmwareCreateLoading) {
              <button [disabled]="viewController" title="Salvar" class="btn btn-success" id="button-new-firmware" (click)="createFirmware()">
                {{ "equipment-type.save-btn" | translate }}
              </button>
              }
              @if (firmwareCreateLoading) {
              <mat-spinner [diameter]="30"></mat-spinner>
              }
            </mat-expansion-panel>
          </mat-accordion>
        </mat-tab>
        <!-- Campos dos comandos -->
        @if (!updateEquipmentTypeForm.value.isGateway) {
        <mat-tab label="Comandos">
          <br />
          <div class="checkbox">
            <section class="checkbox-commands">
              <mat-checkbox (change)="hasClockSyncChecked($event.checked)" formControlName="hasClockSync">
                {{ "equipment-type.has-clock-label" | translate }}
              </mat-checkbox>
            </section>
            <section class="checkbox-commands">
              <mat-checkbox (change)="hasActuationChecked($event.checked)" formControlName="hasActuation">
                {{ "equipment-type.has-actuation-label" | translate }}
              </mat-checkbox>
            </section>
          </div>
          <div class="checkbox">
            <section class="checkbox-commands">
              <mat-checkbox (change)="hasPowerQualityChecked($event.checked)" formControlName="hasPowerQuality">
                {{ "equipment-type.has-power-quality-label" | translate }}
              </mat-checkbox>
            </section>
            <section class="checkbox-commands">
              <mat-checkbox (change)="oldCrcChecked($event.checked)" formControlName="oldCrc">
                {{ "equipment-type.has-old-crc-label" | translate }}
              </mat-checkbox>
            </section>
          </div>
          <br />
          <mat-accordion class="example-headers-align p-0" >
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{ "equipment-type.query-commands" | translate }}
                </mat-panel-title>
                <mat-panel-description>
                  {{ "equipment-type.add-query-commands" | translate }}
                </mat-panel-description>
              </mat-expansion-panel-header>
              <mat-chip-set class="example-chip">
                @if (queryCommands.length > 0) {
                <div class="commands">
                  @for (query of queryCommands; track query; let i = $index) {
                  <mat-chip-set class="example-chip">
                    @if (query.responseProperties && query.type) {
                    <mat-chip class="example-box">
                      <span> {{ query?.responseProperties }}</span>
                      <span>
                        (
                        @if (query?.type === 'STATUS') {
                        <span>
                          {{
                          "equipment-type.queryCommands-status" | translate
                          }}
                        </span>
                        }
                        @if (query?.type === 'PARAMETERS') {
                        <span>
                          {{
                          "equipment-type.queryCommands-parameters"
                          | translate
                          }}
                        </span>
                        }
                        @if (query?.type === 'DIAGNOSTIC') {
                        <span>
                          {{
                          "equipment-type.queryCommands-diagnostic"
                          | translate
                          }}</span>
                        }
                        @if (query?.type === 'MEASUREMENT') {
                        <span>
                          {{
                          "equipment-type.queryCommands-measurement"
                          | translate
                          }}
                        </span>
                        }
                        @if (query?.type === 'LATEST_MEASUREMENT') {
                        <span>
                          {{
                          "equipment-type.queryCommands-latest-measurement"
                          | translate
                          }}</span>
                        }
                        @if (query?.type === 'VERSION') {
                        <span>
                          {{
                          "equipment-type.queryCommands-version" | translate
                          }}
                        </span>
                        }
                        )
                      </span>
                      <button (click)="editQueryCommands(i)" [disabled]="viewController">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" style="cursor: pointer"
                          fill="currentColor" class="bi bi-pencil" viewBox="0 0 16 16">
                          <path
                            d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z" />
                        </svg>
                      </button>
                      <button (click)="clearQueryCommandsByIndex(i)" [disabled]="viewController">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                          class="bi bi-trash3" viewBox="0 0 16 16" style="cursor: pointer">
                          <path
                            d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                        </svg>
                      </button>
                    </mat-chip>
                    }
                  </mat-chip-set>
                  }
                </div>
                }
              </mat-chip-set>
              <button mat-fab extended color="primary" aria-label="Criar comando" title="Adicionar comandos"
                (click)="openModalQueryCommands()" style="margin: 5px" [disabled]="viewController">
                <mat-icon>control_point</mat-icon>
                {{ "equipment-type.add-commands-title" | translate }}
              </button>
            </mat-expansion-panel>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{ "equipment-type.config-commands" | translate }}
                </mat-panel-title>
                <mat-panel-description>
                  {{ "equipment-type.add-config-commands" | translate }}
                </mat-panel-description>
              </mat-expansion-panel-header>
              <mat-chip-set class="example-chip">
                @if (configCommands.length > 0) {
                <div class="commands">
                  @for (commands of configCommands; track commands; let i = $index) {
                  <mat-chip-set class="example-chip">
                    @if (
                    commands.reference &&
                    commands.targetReference &&
                    commands.type
                    ) {
                    <mat-chip class="example-box">
                      <span> {{ commands?.reference }}</span>
                      <span>
                        (
                        @if (commands?.maxValue || commands?.minValue) {
                        <span>
                          {{ commands?.minValue }}, {{ commands?.maxValue }}
                        </span>
                        }
                        @if (commands?.choices) {
                        <span>
                          @for (choice of commands?.choices; track choice) {
                          <span>
                            {{ choice.description }}
                          </span>
                          }
                        </span>
                        }
                        )
                      </span>
                      <button (click)="editConfigCommands(i)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" style="cursor: pointer"
                          fill="currentColor" class="bi bi-pencil" viewBox="0 0 16 16">
                          <path
                            d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z" />
                        </svg>
                      </button>
                      <button (click)="clearConfigCommandsByIndex(i)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                          class="bi bi-trash3" viewBox="0 0 16 16" style="cursor: pointer">
                          <path
                            d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                        </svg>
                      </button>
                    </mat-chip>
                    }
                  </mat-chip-set>
                  }
                </div>
                }
              </mat-chip-set>
              <div class="form-step">
                <button mat-fab extended color="primary" aria-label="Criar comando" title="Adicionar comandos"
                  (click)="openModalConfigCommands()" style="margin: 5px" [disabled]="viewController">
                  <mat-icon>control_point</mat-icon>
                  {{ "equipment-type.add-commands-title" | translate }}
                </button>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </mat-tab>
        }
      </mat-tab-group>
    </div>
    }
  </div>
</div>